import { render, staticRenderFns } from "./DetailBox.vue?vue&type=template&id=e93b9d9a&scoped=true&"
import script from "./DetailBox.vue?vue&type=script&lang=js&"
export * from "./DetailBox.vue?vue&type=script&lang=js&"
import style0 from "./DetailBox.vue?vue&type=style&index=0&id=e93b9d9a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e93b9d9a",
  null
  
)

export default component.exports